import { useEffect, useState } from 'react';
import { apiFetch } from '@/lib/api';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/Button';
import { inputClass, labelClass } from '@/components/ui/inputStyles';

type Props = {
  open: boolean;
  onClose: () => void;
  onSuccess: () => void;
};

export function ChangePasswordModal({ open, onClose, onSuccess }: Props) {
  const [pwdCurrent, setPwdCurrent] = useState('');
  const [pwdNew, setPwdNew] = useState('');
  const [pwdNew2, setPwdNew2] = useState('');
  const [pwdBusy, setPwdBusy] = useState(false);
  const [pwdErr, setPwdErr] = useState<string | null>(null);

  useEffect(() => {
    if (!open) {
      setPwdCurrent('');
      setPwdNew('');
      setPwdNew2('');
      setPwdErr(null);
    }
  }, [open]);

  function close() {
    if (pwdBusy) return;
    onClose();
  }

  async function submit() {
    setPwdErr(null);
    if (pwdNew.length < 6) {
      setPwdErr('新密码至少 6 位');
      return;
    }
    if (pwdNew !== pwdNew2) {
      setPwdErr('两次输入的新密码不一致');
      return;
    }
    setPwdBusy(true);
    try {
      const r = await apiFetch<{ ok: boolean; err?: string; detail?: string }>('change_own_password', {
        method: 'POST',
        body: JSON.stringify({ current_password: pwdCurrent, new_password: pwdNew }),
      });
      if (r.ok) {
        onSuccess();
        onClose();
      } else {
        setPwdErr(r.detail || r.err || '修改失败');
      }
    } catch (e) {
      setPwdErr(e instanceof Error && e.message !== 'SESSION_EXPIRED' ? e.message : '请求失败');
    } finally {
      setPwdBusy(false);
    }
  }

  return (
    <Modal
      open={open}
      onClose={close}
      title="修改密码"
      footer={
        <div className="flex flex-wrap justify-end gap-2">
          <Button type="button" variant="secondary" disabled={pwdBusy} onClick={close}>
            取消
          </Button>
          <Button
            type="button"
            variant="primary"
            disabled={pwdBusy || pwdCurrent === '' || pwdNew === ''}
            onClick={() => void submit()}
          >
            {pwdBusy ? '保存中…' : '保存'}
          </Button>
        </div>
      }
    >
      <div className="space-y-4">
        <p className="text-xs text-slate-500">新密码至少 6 位。保存后其他已登录终端需重新登录。</p>
        {pwdErr ? <p className="text-sm text-rose-600">{pwdErr}</p> : null}
        <label className={labelClass}>
          <span>当前密码</span>
          <input
            type="password"
            className={inputClass}
            value={pwdCurrent}
            onChange={(e) => setPwdCurrent(e.target.value)}
            autoComplete="current-password"
          />
        </label>
        <label className={labelClass}>
          <span>新密码</span>
          <input
            type="password"
            className={inputClass}
            value={pwdNew}
            onChange={(e) => setPwdNew(e.target.value)}
            autoComplete="new-password"
          />
        </label>
        <label className={labelClass}>
          <span>确认新密码</span>
          <input
            type="password"
            className={inputClass}
            value={pwdNew2}
            onChange={(e) => setPwdNew2(e.target.value)}
            autoComplete="new-password"
          />
        </label>
      </div>
    </Modal>
  );
}
